var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(" Departments ")]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    _vm._l(_vm.departments, function (department) {
                      return _c("w-checkbox", {
                        key: department,
                        attrs: {
                          label: _vm.translateDepartment(department),
                          value: _vm.isDepartmentSelected(department),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onDepartmentChange(department, $event)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }